import React, { useMemo, } from 'react';
import Community from '@op/pages/Overview/KeyMetrics/Community';
import useGameCompetitor from '@op/pages/competitor/hooks/useGameCompetitor';
import { arrayToObj } from '@op/utils';
import { distinguishOfficialAccounts } from '@op/components/FilterCommon/utils/monitorUtil';
import CardLoading from '@op/components/CardLoading';
import './index.scss';

function OpinionsPosts(props: any) {
  const { className = '', gameInfo, wholeGameInfo, filter, filterCond, filterLoading, showRank = true, defaultTab = "posts", extraParams, id, refArray, index, style } = props;

  // 使用useMemo钩子函数，根据extraParams和filter属性，生成新的filter对象
  const newFilter = useMemo(() => {
    if (!filter?.date_type || !filterCond) return null;
    const { entity_image, isConfirm, ...restFilter } = filter || {};
    return { 
      ...(restFilter || {}),
      social_media_by_account: filterCond?.social_media_by_account || undefined,
      social_media_by_keyword: undefined,
      ...extraParams 
    };
  }, [filter, filterCond, extraParams]);

  // 使用useGameCompetitor钩子函数，从props中解构出competitorGame和loading属性
  const {
    competitorGame,
    loading,
  } = useGameCompetitor({ filter: newFilter, gameInfo });

  // 使用useMemo钩子函数，根据competitorGame和filterCond属性，生成games、competitorGames、officialAccount等对象
  const { games, competitorGames, officialAccount } = useMemo(() => {
    const games = competitorGame?.map(
      ({
        edition_unified_id,
        entity_type,
        id_type,
        release_time,
      }: any) => {
        if (!edition_unified_id) return null;
        return {
          edition_unified_id,
          entity_type,
          id_type,
          release_time,
        };
      },
    )?.filter(Boolean);
    const competitorGames = arrayToObj(competitorGame, 'edition_unified_id');
    const { monitor_by_account_category } = filterCond || {};
    const account = distinguishOfficialAccounts(
      monitor_by_account_category?.monitory || {},
    );
    const officialAccount = account?.['official-accounts'] || [];
    return { games, competitorGames, officialAccount };
  }, [competitorGame, filterCond]);

  return (
    <div className={`${className} dbo-page-metrics dbh-studio-opinions-posts`} id={id} data-scroll-index={index} ref={refArray?.[index]} style={style}>
      <CardLoading loading={filterLoading || loading}>
        {
          games?.length > 0 && <Community
            filter={newFilter}
            gameInfo={gameInfo}
            defaultTab={defaultTab}
            officialAccount={officialAccount}
            wholeGameInfo={wholeGameInfo}
            games={games}
            gameData={competitorGames}
            showRank={showRank}
            canNavigateToGame={true}
          ></Community>
        }
      </CardLoading>
    </div>
  );
}

export default OpinionsPosts;
